import { render, staticRenderFns } from "./dashboard-item.vue?vue&type=template&id=496c2228&"
import script from "./dashboard-item.vue?vue&type=script&lang=js&"
export * from "./dashboard-item.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports